import { fetchCurrentUser } from '../../ducks/user.duck';
import { denormalisedEntities } from '../../util/data';
import { storableError } from '../../util/errors';
import { parse } from '../../util/urlHelpers';

import { types as sdkTypes } from '../../util/sdkLoader';
const { Money } = sdkTypes;

// ================ Action types ================ //

const ActionTypes = {
  SET_INITIAL_STATE: 'app/WalletDashboardPage/SET_INITIAL_STATE',

  SET_STOCK_REQUEST: 'app/WalletDashboardPage/SET_STOCK_REQUEST',
  SET_STOCK_SUCCESS: 'app/WalletDashboardPage/SET_STOCK_SUCCESS',
  SET_STOCK_ERROR: 'app/WalletDashboardPage/SET_STOCK_ERROR',
};

// ================ Initial State ================ //

const initialState = {
  setStockInProgress: false,
  setStockError: null,
};

// ================ Reducers ================ //

const WalletDashboardPageReducer = (state = initialState, { type, payload } = {}) => {
  switch (type) {
    case ActionTypes.SET_STOCK_REQUEST:
      return { ...state, setStockInProgress: true, setStockError: null };
    case ActionTypes.SET_STOCK_SUCCESS:
      return { ...state, setStockInProgress: false };
    case ActionTypes.SET_STOCK_ERROR:
      return { ...state, setStockInProgress: false, setStockError: payload };

    default:
      return state;
  }
};

// ================ Selectors ================ //

export const createDraftInProgressSelector = state =>
  state.WalletDashboardPage.createDraftInProgress;

/**
 * Get the denormalised own listing entities with the given IDs
 *
 * @param {Object} state the full Redux store
 * @param {Array<UUID>} listingIds listing IDs to select from the store
 */
export const getOwnListingsById = (state, listingIds) => {
  const { ownEntities } = state.WalletDashboardPage;
  const resources = listingIds.map(id => ({
    id,
    type: 'ownListing',
  }));
  const throwIfNotFound = false;
  return denormalisedEntities(ownEntities, resources, throwIfNotFound);
};

// ================ Actions Creators ================ //

export const setStockRequest = () => ({ type: ActionTypes.SET_STOCK_REQUEST });
export const setStockSuccess = () => ({ type: ActionTypes.SET_STOCK_SUCCESS });
export const setStockError = e => ({ type: ActionTypes.SET_STOCK_ERROR, error: true, payload: e });

export const setInitialState = () => ({
  type: ActionTypes.SET_INITIAL_STATE,
});

// ================ Thunks ================ //

export const compareAndSetStock = (listingId, oldTotal, newTotal) => async (
  dispatch,
  getState,
  sdk
) => {
  try {
    dispatch(setStockRequest());

    // Update stock using SDK with compareAndSet
    const response = await sdk.stock.compareAndSet(
      { listingId, oldTotal, newTotal },
      { expand: true }
    );

    // Update client app's state with the response
    dispatch(setStockSuccess());
  } catch (e) {
    log.error(e, 'update-stock-failed', { listingId, oldTotal, newTotal });
    dispatch(setStockError(storableError(e)));
  }
};

// Thunks
export const loadData = (params, search, config) => async (dispatch, getState, sdk) => {
  dispatch(setInitialState());
  const queryParams = parse(search, {
    latlng: ['origin'],
    latlngBounds: ['bounds'],
  });

  const { listingState, page = 1, searchTerm, shop, userId, connected, ...rest } =
    queryParams || {};
  const currentUser = await dispatch(fetchCurrentUser({ enforce: true }));
  const currentUserId = currentUser?.id;

  return currentUser;
};

export default WalletDashboardPageReducer;
